"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperTextStyles = exports.menuItemStyles = exports.selectPlaceholderStyles = exports.filledSelectStyles = exports.openSelectStyles = exports.selectStyles = void 0;
const styled_components_1 = require("styled-components");
exports.selectStyles = (0, styled_components_1.css) `
  .MuiInputBase-root {
    box-shadow: none;
    ${({ theme }) => theme.typography.variants.primary.main};
    opacity: 1;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${({ theme }) => theme.palette.gray[50]};
    border-radius: ${({ theme }) => theme.constants.borderRadius};
    transition: 0.2s ease all;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
  }

  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    background-color: transparent;
    border-width: 1px;
    border-color: ${({ theme }) => theme.palette.primary.main};
    background-color: transparent;
  }

  .MuiSelect-select:focus {
    background-color: transparent;
  }
`;
exports.openSelectStyles = (0, styled_components_1.css) `
  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
exports.filledSelectStyles = (0, styled_components_1.css) `
  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`;
exports.selectPlaceholderStyles = (0, styled_components_1.css) `
  color: ${({ theme }) => theme.palette.gray[70]};
`;
exports.menuItemStyles = (0, styled_components_1.css) `
  height: 54px;
  background-color: ${({ theme }) => theme.palette.gray[0]};
  transition: 0.2s ease all;

  &.Mui-selected:hover,
  &.Mui-focusVisible,
  &:hover {
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.primary.main};
  }

  &.Mui-selected {
    color: ${({ theme }) => theme.palette.gray[100]};
    background-color: ${({ theme }) => theme.palette.gray[0]};
  }
`;
exports.HelperTextStyles = (0, styled_components_1.css) `
  &.MuiFormHelperText-root {
    ${({ theme }) => theme.typography.variants.primary.main};
    color: ${({ theme }) => theme.palette.gray[70]};
    opacity: 1;
    font-size: ${({ theme }) => theme.typography.Size.Small};
    margin-left: 14px;

    &.Mui-error {
      color: ${({ theme }) => theme.palette.status.error};
    }

    &.Mui-disabled {
      color: ${({ theme }) => theme.palette.gray[30]};
    }
  }
`;
//# sourceMappingURL=styles.js.map